var _defs, _g, _rect;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1080 1080",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-1, .cls-4 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 20px;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 300.27,
    cy: 149.42,
    fx: 300.27,
    fy: 149.42,
    r: 871.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613bdd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M982.58,720.08c11.91-58.31,18.17-118.68,18.17-180.5s-6.26-122.19-18.17-180.5c-18.56-129.47-119.73-232.28-248.39-253.31-60.11-12.69-122.44-19.37-186.32-19.37s-126.21,6.68-186.33,19.37c-126.56,20.69-226.52,120.51-247.41,247-12.76,60.26-19.48,122.75-19.48,186.82s6.72,126.55,19.48,186.82c20.78,125.79,119.74,225.19,245.3,246.65,60.76,12.98,123.8,19.82,188.44,19.82s127.68-6.84,188.44-19.82c127.65-21.81,227.8-124.2,246.27-252.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M388.66,817.12"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M724.4,508c-5.28-11.89-17.08-19.56-30.09-19.56h-69.22v-177.62c0-18.19-14.75-32.93-32.93-32.93h-88.92c-18.19,0-32.93,14.74-32.93,32.93v177.62h-69.21c-13.01,0-24.81,7.66-30.09,19.56-5.29,11.89-3.08,25.78,5.64,35.43l146.61,162.45c6.24,6.92,15.13,10.87,24.45,10.87s18.2-3.95,24.45-10.87l146.61-162.45c8.72-9.66,10.94-23.55,5.64-35.44Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 388.66,
    y1: 801.35,
    x2: 715.27,
    y2: 801.35
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -78.25,
    y: -106.75,
    width: 1292.75,
    height: 1292.75
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.76e682ac.svg";
export { ForwardRef as ReactComponent };